<template>
    <div class="container">
        <div class="cart-item">
            <div>
                <div class="store">
                    <i class="iconfont">&#xe62d;</i>
                    <span>{{storeCartList.store_name}}</span>
                </div>

                <div class="buy-item">
                    <div class="goods-pic"><img :src="storeCartList.goods_image_url"/></div>
                    <div class="goods-info">
                        <dl>
                            <dt class="goods-name">{{storeCartList.goods_name}}</dt>
                            <dd class="goods-subtotal">
                                <span class="goods-price">${{storeCartList.goods_price}}</span><span v-if="storeCartList.goods_price<storeCartList.goods_original_price" class="ml-5 goods-original-price">{{storeCartList.goods_original_price}}</span>
                                <span class="goods-count">×{{storeCartList.quantity}}</span>
                            </dd>
                        </dl>
                    </div>
                </div>
            </div>
            <div class="cart-subtotal">
                <div class="message">
                    <flex-line class="field-line" :show-border="true"><div class="field-line-right" slot="right"><textarea class="order-message field-input" v-model="message" placeholder="店铺订单留言:" @change="changeMessage()" ></textarea></div></flex-line>
                </div>
                <div v-if="storeCartList.store_voucher_list.length" @click="voucherVisible=true">
                    <flex-line class="menu-item" :is-link="true" :show-border="true">
                        <div>
                            <span class="left-icon iconfont">&#xe6f2;</span>
                            <span>代金券</span>
                        </div>
                        <span slot="right">{{myVoucher}}</span>
                    </flex-line>
                </div>
                <checkout-desc class="desc-item mt-5" title="商品金额" v-if="storeCartList.goods_discount_total>0" :subtitle="storeCartList.goods_original_total"></checkout-desc>
                <checkout-desc class="desc-item" title="优惠" v-if="storeCartList.goods_discount_total>0" :subtitle="storeCartList.goods_discount_total" :discount="true"></checkout-desc>
                <checkout-desc class="desc-item" title="本店合计" :subtitle="totalAmount"></checkout-desc>
            </div>
            <mt-popup v-model="voucherVisible" position="right" class="common-popup-wrapper">
                <div class="common-header-wrap">
                    <mt-header title="代金券" class="common-header">
                        <mt-button slot="left" icon="back" @click="voucherVisible=false"></mt-button>
                        <div class="common-btn btn" slot="right" @click="selectVoucher('')">不使用</div>
                    </mt-header>
                </div>
                <div class="common-popup-content">
                    <div class="common-voucher common-voucher02" :class="(item.voucher_state != 1)?'disable':''" v-for="(item,index) in storeCartList.store_voucher_list" :key="item.voucher_id" @click="selectVoucher(item)">
                        <div class="par"><p>订单满{{item.voucher_limit}}元</p><sub class="sign">$</sub><span>{{item.voucher_price}}</span></div>
                        <div class="copy">有效期至<p><br>{{$moment.unix(item.voucher_enddate).format('YYYY.MM.DD')}}</p></div>
                        <i></i>
                    </div>
                </div>
            </mt-popup>
        </div>
    </div>
</template>

<script>
import CheckoutDesc from './CheckoutDesc'
import flexLine from '../../../flexLine'
export default {
  name: 'CheckoutStore',
  data () {
    return {
      totalAmount: '',
      voucherVisible: [],
      message: '',
      myVoucher: '',
      voucherVisible: false
    }
  },
  components: {
    flexLine,
    CheckoutDesc
  },
  props: ['storeCartList'],
  created: function () {
    this.calcOrder()
  },
  methods: {
    changeMessage () {
      this.$emit('changeMessage', this.message)
    },
    selectVoucher (voucherInfo) {
      this.voucherVisible = false
      this.$emit('selectVoucher', voucherInfo)
      this.storeCartList.store_voucher_info = voucherInfo
      this.calcOrder()
    },
    calcOrder () {
      let price = parseFloat(this.storeCartList.goods_total)
      if (this.storeCartList.store_voucher_list.length) {
        if (this.storeCartList.store_voucher_info) {
          price -= parseFloat(this.storeCartList.store_voucher_info.voucher_price)

          this.myVoucher = this.storeCartList.store_voucher_info.voucher_price + '元'
        } else {
          this.myVoucher = '不使用'
        }
      }
      if (price < 0) {
        price = 0
      }
      this.totalAmount = price
    }

  }
}
</script>

<style scoped lang="scss">
.common-header{
        .btn{background: #000;color: #fff;box-shadow: 0px 2px 4px #d2d2d2;}
    }
    .container{background: #fff;padding:0 $pageSpace}
    .store{    position: relative;
        z-index: 1;
        display: block;
        height: 0.9rem;
        padding: 0.4rem 0;
        font-size:$subFontSize;
        line-height: 0.9rem;
        background: #fff;
        font-weight: 700;
    }
    .store i{
        font-size: $h2;
        margin-right: 0.2rem;
        color:$primaryColor;
    }
    .cart-item{background-color: #FFF;
        border-bottom: solid 0.05rem #EEE;}
    .buy-item{    display: block;
        position: relative;
        z-index: 1;
        margin:.5rem 0;
        box-shadow: 0px 4px 4px #f7f7f7;
    }
    .buy-item .goods-pic{display: block;
        width: 3rem;
        height: 3rem;
        position: absolute;
        z-index: 1;
        top: 0rem;
        left: 0rem;
    }
    .buy-item .goods-pic img{width:100%;
        height:100%;border-radius: 0.2rem;}
    .buy-item .goods-info{    display: block;
        vertical-align: top;
        height: 3.1rem;
        margin-left:4rem;
        position: relative;
        z-index: 1;}
    .buy-item .goods-info .goods-name  {
        height:1.6rem;
        font-size:$subFontSize;
        line-height: .8rem;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        display: box;
        line-clamp: 2;
        box-orient: vertical;
        margin-bottom:.5rem;
        font-weight: normal;
        .tag-icon{vertical-align: top}
    }
    .buy-item .goods-info  .goods-type {
        overflow: hidden;
        white-space: nowrap;
        width: 70%;
        height: 0.9rem;
        font-size:$h6;
        line-height: 0.9rem;
        color: #999;
        text-overflow: ellipsis;
    }
    .buy-item .goods-info .goods-original-price{text-decoration: line-through;font-size:$fontSize;color:$descTextColor;font-weight: normal}
    .buy-item .goods-info  .goods-subtotal {
        display: block;
        height: 1rem;
        margin: 0 0.4rem 0 0rem;
        line-height: 1rem;
        font-size:$subFontSize;
        position: relative;
        z-index: 1;
    }
    .buy-item .goods-info  .goods-subtotal .goods-price {
        color: #DB4453;
        font-size:$subFontSize;
        font-weight: 600;
    }
    .buy-item .goods-info  .goods-subtotal  .goods-count {
        font-size:$subFontSize;
        line-height: 1rem;
        position: absolute;
        z-index: 1;
        top: 0rem;
        right: 0rem;
        font-weight: normal;
        color:$descTextColor
    }
    .cart-subtotal{}
    .cart-subtotal dl {
        position: relative;
        z-index: 1;
        height: 1rem;
        padding: 0.4rem 0 0;
        font-size: 0;
    }
    .cart-subtotal dt {
        position: absolute;
        z-index: 1;
        top: 0.4rem;
        left: 0.4rem;
        display: block;
        width: 50%;
        height: 1rem;
        font-size:$fontSize;
        line-height: 1rem;
    }
    .cart-subtotal dd {
        height: 1rem;
        margin: 0 0.4rem 0 50%;
        text-align: right;
        font-size:$fontSize;
        line-height: 1rem;
    }
    .cart-subtotal .message {
        position: relative;
        z-index: 1;
        display: block;
        .order-message{background: #FBFBFB;margin:.5rem 0;font-size:$fontSize;padding:.5rem;height: 3rem;border: 0}
    }
    .desc-item {
        height: 1.5rem;
    }
    .common-voucher{margin:0.5rem auto}
    .left-icon{float:left;font-size:$h1;margin-right:0.2rem;}
</style>
